<lb-profile-info-box infoBoxIcon="untitled-ui/maps/marker-pin-01" [formGroup]="form()">
	<ng-content right>
		<lb-form-row>
			<lb-form-field>
				<label>Street Address</label>
				<input type="text" md-form-input formControlName="streetAddress" />
			</lb-form-field>
		</lb-form-row>

		<lb-form-row>
			<lb-form-field>
				<label>Apartment, Suite, etc</label>
				<input type="text" md-form-input formControlName="streetAddress2" />
			</lb-form-field>

			<lb-form-field>
				<label>City</label>
				<input type="text" md-form-input formControlName="city" />
			</lb-form-field>
		</lb-form-row>

		<lb-form-row>
			<lb-form-field>
				<label>State</label>
				<input type="text" md-form-input formControlName="state" />
			</lb-form-field>

			<lb-form-field>
				<label>Postal Code</label>
				<input type="text" md-form-input formControlName="postalCode" />
			</lb-form-field>
		</lb-form-row>

		<lb-form-row>
			<lb-form-field>
				<label>Country/Region</label>
				<input type="text" md-form-input formControlName="country" />
			</lb-form-field>

			<lb-form-field>
				<label>Time zone</label>
				<md-drop-down [options]="timeZoneOptions()" placeholder="Make a selection..." formControlName="timezone"></md-drop-down>
			</lb-form-field>
		</lb-form-row>
	</ng-content>
</lb-profile-info-box>
